import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { DownloadOutlined, DownOutlined, LoadingOutlined } from '@ant-design/icons';
import '@ant-design/compatible/assets/index.css';
import { Col, Button, Popconfirm, Popover, Select, Input, Dropdown, Spin, Menu, Row } from 'antd';
import {
	assetsRestCrudThunksForSupplier,
	cancelScheduledAssetTransfer,
	downloadAssetCSVForSupplier,
} from '../../thunks/assets_thunks';
import { EmptyState } from '../empty_state/EmptyState';
import { ASSETS_CRUD_ACTION_CREATORS } from '../../actions/assets_actions';
import {
	nullSafeGet,
	nullSafeGetOrElse,
	changeFilterValueToArrayOfIds,
	getStartDateFieldName,
	getEndDateFieldName,
	getTupleNameFieldName,
	getTupleValueFieldName,
} from '../../utils/DataAccessUtils';
import { locationsRestCrudThunksForSupplier } from '../../thunks/locations_thunks';
import { assetTypesRestCrudThunksForSupplier } from '../../thunks/asset_types_thunks';
import { regionsRestCrudThunksForSupplier } from '../../thunks/regions_thunks';
import RegionsLocationsTreeSelect from '../regions_tree_select/SupplierRegionsLocationsTreeSelect';
import OWAsyncTreeSelect from '../ow_async_tree_select/OWAsyncTreeSelect';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import { FILTER_CONFIG_NAMES, FILTER_FIELD_TYPE, ROLE_TYPES } from '../../utils/DataConstants';
import { depreciationClassesRestCrudThunksForSupplier } from '../../thunks/depreciation_class_thunks';
import OWDateRangePicker from '../ow_date_range_picker/OWDateRangePicker';
import moment from 'moment';
import {
	decodeUTCAdjustedDate,
	encodeUTCAdjustedDate,
	formatDateForParam,
} from '../../utils/DataFormatterUtils';
import { downloadAssetNBVCSVForSupplier } from '../../thunks/asset_nbvs_thunks';
import AssetWithQRCodeDisplay from '../asset_row_display/AssetWithQRCodeDisplay';
import { assetTypesAdditionalFieldsRestCrudThunksForSupplier } from '../../thunks/asset_types_additional_fields_thunks';
import OWAsyncTupleSelect from '../ow_async_select/OWAsyncTupleSelect';
import {
	getBuyerCompanySettingValue,
	isInternalTech,
	PERMISSION_NAMES,
} from '../../utils/AuthUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { getIsActiveFilterField, INITIAL_ACTIVE_FILTERS } from '../../utils/FilterUtils';
import ReduxDataTable from '../redux_data_table/ReduxDataTable';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import { areasRestCrudThunksForSupplier, fetchAreasWithHeirarchy } from '../../thunks/areas_thunks';
import { vendorsRestCrudThunksForSupplier } from '../../thunks/vendors_thunks';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
import BulkTransferToStockLocationModal from './BulkTransferToStockLocationModal';
import BulkTransferToLocationModal from './BulkTransferToLocationModal';
import BulkTransferAssetsButton from '../assets_overview_page/BulkTransferAssetsButton';

const queryString = require('qs');

require('./SupplierAssetsIndexPage.less');

const ASSETS_OVERVIEW_TARGET_COLLECTION = 'assetsIndex';
const ASSETS_ADVANCED_FILTERS = 'assetsAdvancedFilters';

class SupplierAssetsIndexPage extends React.Component<any, any> {
	initialPagination: any;
	initialFilters: any;

	state = {
		showDepreciationClassFilter: false,
		nbvDownloading: false,
		selectedRowKeys: [] as any[],
		selectedRows: [] as any[],
		showTransferToStockLocation: false,
		showTransferToLocation: false,
	};

	constructor(props) {
		super(props);
		const { location, history } = props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const { current, pageSize, total, sort_by, order, ...assetFilters } = queryParams;
		this.initialFilters = assetFilters || {};
		this.initialPagination = {
			current: current ? parseInt(current) : 1,
			pageSize: pageSize ? parseInt(pageSize) : 10,
		};
		history.push(`/supplier/assets/overview/all?${new URLSearchParams(location.search)}`);
	}

	downloadCSV = () => {
		const { assets, downloadAssetCSV } = this.props;
		const filters = assets[ASSETS_OVERVIEW_TARGET_COLLECTION].filters;
		downloadAssetCSV({}, filters);
	};

	componentDidMount() {
		const { fetchDepreciationClasses } = this.props;
		fetchDepreciationClasses({}, undefined, { pageSize: 1 }).then(
			(res) =>
				nullSafeGet('length', res) > 0 && this.setState({ showDepreciationClassFilter: true })
		);
	}

	cancelTransfer = () => {
		const { cancelScheduledTransfer } = this.props;
		const { selectedRowKeys } = this.state;
		cancelScheduledTransfer({ assetIds: selectedRowKeys }).then(() => {
			this.setState({ selectedRowKeys: [], selectedRows: [] });
			this.refreshAssets();
		});
	};

	refreshAssets = () => {
		const { assets, fetchAssets } = this.props;
		const pagination = nullSafeGetOrElse(
			`${ASSETS_OVERVIEW_TARGET_COLLECTION}.pagination`,
			assets,
			{}
		);
		const sorting = nullSafeGetOrElse(`${ASSETS_OVERVIEW_TARGET_COLLECTION}.sorting`, assets, {});
		const filters = nullSafeGetOrElse(`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters`, assets, {});
		fetchAssets(null, ASSETS_OVERVIEW_TARGET_COLLECTION, pagination, sorting, filters);
	};

	downloadNBVCsv = () => {
		const { assets, downloadAssetNBV } = this.props;
		const filters = assets[ASSETS_OVERVIEW_TARGET_COLLECTION].filters;
		this.setState({ nbvDownloading: true });
		downloadAssetNBV({}, filters).finally(() => this.setState({ nbvDownloading: false }));
	};

	render() {
		const {
			history,
			location,
			assets,
			fetchLocations,
			fetchMultipleLocations,
			locations,
			fetchAssetTypes,
			fetchMultipleAssetTypes,
			assetTypes,
			updateAssetsFilters,
			areas,
			fetchAreas,
			fetchMultipleAreas,
			depreciationClasses,
			fetchDepreciationClasses,
			fetchMultipleDepreciationClasses,
			assetTypesAdditionalFields,
			fetchAssetTypesAdditionalFields,
			fetchMultipleAssetTypesAdditionalFields,
			currentUser,
			vendors,
			fetchVendors,
			fetchMultipleVendors,
		} = this.props;

		const onRow = (record) => ({
			onClick: () => {
				const path = `/supplier/assets/detail/${nullSafeGet('id', record)}/details`;
				history.push(
					getLinkWIthBackLinkParams(location, 'Back to Assets', path, {
						preserve: true,
						targetCollectionName: ASSETS_OVERVIEW_TARGET_COLLECTION,
					})
				);
			},
		});

		const columns = [
			{
				title: 'Name',
				dataIndex: 'name',
				defaultSortOrder: 'ascend',
				render: (text, record) => <AssetWithQRCodeDisplay asset={record} />,
			},
		];

		const allowArea = getBuyerCompanySettingValue(ROLE_TYPES.SUPPLIER)(
			'assetConfig.allowAreaAssociationWithAssets',
			{},
			currentUser,
			false
		);

		const filterConfig = [
			{
				label: 'Location',
				fieldName: 'locationIds',
				stateSlice: locations,
				mode: 'multiple',
				filtersValueAccessor: (filtersStateSlice) => {
					const locationIds = nullSafeGet(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.locationIds`,
						filtersStateSlice
					);
					const finalIds = nullSafeGetOrElse(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.regionIds`,
						filtersStateSlice,
						locationIds
					);
					return changeFilterValueToArrayOfIds(finalIds);
				},
				keyAccessor: (loc) => loc.id,
				valueAccessor: (loc) => loc.id,
				handleChange: (ids) => {
					updateAssetsFilters(
						{
							locationIds: ids.join(',') || undefined,
							regionIds: undefined,
						},
						ASSETS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'assetsAdvancedFilters',
				fetch: fetchLocations,
				fetchMultiple: fetchMultipleLocations,
				renderItem: (loc) => loc.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
				component: RegionsLocationsTreeSelect,
			},
			...(allowArea
				? [
						{
							label: 'Area',
							mode: 'multiple',
							fieldName: 'areaIdsOrNull',
							stateSlice: areas,
							filtersValueAccessor: (filtersStateSlice) => {
								const ids = nullSafeGet(
									`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.areaIdsOrNull`,
									filtersStateSlice
								);
								return changeFilterValueToArrayOfIds(ids);
							},
							keyAccessor: (area) => area.id,
							valueAccessor: (area) => area.id,
							handleChange: (ids) => {
								updateAssetsFilters(
									{
										areaIdsOrNull: ids.join(',') || undefined,
									},
									ASSETS_OVERVIEW_TARGET_COLLECTION
								);
							},
							targetCollectionName: 'assetsAdvancedFilters',
							fetch: fetchAreas,
							fetchMultiple: fetchMultipleAreas,
							renderItem: (area) => area.name,
							sortBy: { sort_by: 'name', order: 'ascend' },
							component: ProblemTypeTreeSelect,
						},
				  ]
				: []),
			{
				label: 'Asset Type',
				fieldName: FILTER_CONFIG_NAMES.ASSET_TYPE,
				mode: 'multiple',
				stateSlice: assetTypes,
				filtersValueAccessor: (filtersStateSlice) => {
					const ids = nullSafeGet(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.assetTypeIds`,
						filtersStateSlice
					);
					return changeFilterValueToArrayOfIds(ids);
				},
				keyAccessor: (assetType) => assetType.id,
				valueAccessor: (assetType) => assetType.id,
				handleChange: (ids) => {
					updateAssetsFilters(
						{
							assetTypeIds: ids.join(',') || undefined,
						},
						ASSETS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'assetsAdvancedFilters',
				fetch: fetchAssetTypes,
				fetchMultiple: fetchMultipleAssetTypes,
				renderItem: (assetType) => assetType.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
				component: OWAsyncTreeSelect,
			},
			{
				component: Input,
				placeholder: 'Search for a manufacturer',
				handleChange: (e) => {
					updateAssetsFilters(
						{
							manufacturer: e.target.value || undefined,
						},
						ASSETS_OVERVIEW_TARGET_COLLECTION
					);
				},
				label: 'Manufacturer',
				fieldName: 'manufacturer',
				type: FILTER_FIELD_TYPE.SEARCH,
				filtersValueAccessor: (filtersStateSlice) =>
					nullSafeGet(`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.manufacturer`, assets),
				renderItem: (loc) => loc,
				valueAccessor: (loc) => loc,
			},

			...(isInternalTech(currentUser)
				? [
						{
							label: 'Vendor',
							fieldName: 'vendorIds',
							mode: 'multiple',
							stateSlice: vendors,
							targetCollectionName: ASSETS_OVERVIEW_TARGET_COLLECTION,
							fetch: fetchVendors,
							fetchMultiple: fetchMultipleVendors,
						},
				  ]
				: []),
			...(this.state.showDepreciationClassFilter
				? [
						{
							label: 'Depreciation Class',
							fieldName: 'depreciationClassIds',
							mode: 'multiple',
							stateSlice: depreciationClasses,
							filtersValueAccessor: (filtersStateSlice) => {
								const ids = nullSafeGet(
									`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.depreciationClassIds`,
									filtersStateSlice
								);
								return changeFilterValueToArrayOfIds(ids);
							},
							keyAccessor: (dc) => dc.id,
							valueAccessor: (dc) => dc.id,
							handleChange: (ids) => {
								updateAssetsFilters(
									{
										depreciationClassIds: ids.join(',') || undefined,
									},
									ASSETS_OVERVIEW_TARGET_COLLECTION
								);
							},
							targetCollectionName: ASSETS_ADVANCED_FILTERS,
							fetch: fetchDepreciationClasses,
							fetchMultiple: fetchMultipleDepreciationClasses,
							renderItem: (dc) => dc.name,
							sortBy: { sort_by: 'name', order: 'ascend' },
							component: OWAsyncTreeSelect,
						},
				  ]
				: []),
			{
				label: 'Additional Fields',
				fieldName: FILTER_CONFIG_NAMES.ADDITIONAL_FIELD,
				type: FILTER_FIELD_TYPE.TUPLE,
				stateSlice: assetTypesAdditionalFields,
				filtersValueAccessor: (filtersStateSlice) => {
					const name = nullSafeGet(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.${getTupleNameFieldName(
							FILTER_CONFIG_NAMES.ADDITIONAL_FIELD
						)}`,
						filtersStateSlice
					);
					const value = nullSafeGet(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.${getTupleValueFieldName(
							FILTER_CONFIG_NAMES.INSTALL_AT
						)}`,
						filtersStateSlice
					);
					return [name, value];
				},
				handleChange: (values) => {
					updateAssetsFilters(
						{
							[getTupleNameFieldName(FILTER_CONFIG_NAMES.ADDITIONAL_FIELD)]: nullSafeGetOrElse(
								'0',
								values,
								undefined
							),
							[getTupleValueFieldName(FILTER_CONFIG_NAMES.ADDITIONAL_FIELD)]: nullSafeGetOrElse(
								'1',
								values,
								undefined
							),
						},
						ASSETS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'assetsAdvancedFilters',
				fetch: fetchAssetTypesAdditionalFields,
				fetchMultiple: fetchMultipleAssetTypesAdditionalFields,
				renderRecord: (entity) => (
					<Select.Option key={entity.id} value={entity.id}>
						<div className="flex flex-row items-center">
							<div>{entity.name}</div>
						</div>
					</Select.Option>
				),
				valueAccessor: (item) => item.name,
				component: OWAsyncTupleSelect,
			},
			{
				label: 'Installed Between',
				labelPrefix: 'Installed',
				fieldName: FILTER_CONFIG_NAMES.INSTALL_AT,
				type: FILTER_FIELD_TYPE.DATE_RANGE,
				filtersValueAccessor: (filtersStateSlice) => {
					const startDate = decodeUTCAdjustedDate(
						nullSafeGet(
							`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.${getStartDateFieldName(
								FILTER_CONFIG_NAMES.INSTALL_AT
							)}`,
							filtersStateSlice
						)
					);
					const endDate = decodeUTCAdjustedDate(
						nullSafeGet(
							`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.${getEndDateFieldName(
								FILTER_CONFIG_NAMES.INSTALL_AT
							)}`,
							filtersStateSlice
						)
					);
					return [startDate && moment(startDate), endDate && moment(endDate)];
				},
				handleChange: (values) => {
					updateAssetsFilters(
						{
							[getStartDateFieldName(FILTER_CONFIG_NAMES.INSTALL_AT)]:
								values && values.length > 0 && values[0]
									? formatDateForParam(encodeUTCAdjustedDate(values[0]))
									: undefined,
							[getEndDateFieldName(FILTER_CONFIG_NAMES.INSTALL_AT)]:
								values && values.length > 1 && values[1]
									? formatDateForParam(encodeUTCAdjustedDate(values[1], true))
									: undefined,
						},
						ASSETS_OVERVIEW_TARGET_COLLECTION
					);
				},
				renderRecord: (item) => item,
				valueAccessor: (item) => item,
				component: OWDateRangePicker,
			},
			{
				fieldName: 'hasWarranty',
				type: 'radioGroup',
				items: [
					{
						label: 'All',
						value: 'undefined',
					},
					{
						label: 'Under Warranty',
						value: 'true',
					},
				],
				filtersValueAccessor: (filtersStateSlice) => {
					const filters = nullSafeGet(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters`,
						filtersStateSlice
					);
					return typeof filters.hasWarranty === 'undefined'
						? 'undefined'
						: `${filters.hasWarranty}`;
				},
				defaultValue: undefined,
				keyAccessor: (item) => item.value,
				valueAccessor: (item) => item.value,
				handleChange: (hasWarranty) => {
					const val = hasWarranty === 'undefined' ? undefined : true;
					updateAssetsFilters({ hasWarranty: val }, ASSETS_OVERVIEW_TARGET_COLLECTION);
				},
				renderRecord: (item) => item.label,
				component: OWRadioGroup,
				info: [
					{
						title: 'Under Warranty',
						description: `Assets that are under warranty`,
					},
				],
			},
			{
				fieldName: 'downtimeStatus',
				type: 'radioGroup',
				items: [
					{
						label: 'All',
						value: undefined,
					},
					{
						label: 'Online',
						value: 'online',
					},
					{
						label: 'Offline',
						value: 'offline',
					},
				],
				filtersValueAccessor: (filtersStateSlice) =>
					nullSafeGet(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.downtimeStatus`,
						filtersStateSlice
					),
				keyAccessor: (item) => item.value,
				valueAccessor: (item) => item.value,
				handleChange: (downtimeStatus) =>
					updateAssetsFilters({ downtimeStatus }, ASSETS_OVERVIEW_TARGET_COLLECTION),
				renderRecord: (item) => item.label,
				component: OWRadioGroup,
				info: [
					{
						title: 'Online',
						description: 'Asset is working and in good condition.',
					},
					{
						title: 'Offline',
						description: 'Asset is not working at this moment.',
					},
				],
			},
			...[getIsActiveFilterField(updateAssetsFilters, ASSETS_OVERVIEW_TARGET_COLLECTION)],
		];
		const { selectedRowKeys, selectedRows, showTransferToStockLocation, showTransferToLocation } =
			this.state;

		const hasScheduledSelected = selectedRows.some((r) => r.nextScheduledTransfer);
		const hasUnscheduledSelected = selectedRows.some((r) => !r.nextScheduledTransfer);

		const downloadMenu = (
			<Menu>
				<Menu.Item onClick={this.downloadCSV}>Export CSV</Menu.Item>
				<AccessPermissionChecker name={PERMISSION_NAMES.SHOW_ASSET_PRICE}>
					<Menu.Item onClick={this.downloadNBVCsv}>Net Book Value</Menu.Item>
				</AccessPermissionChecker>
			</Menu>
		);

		const transferMenu = (
			<Menu>
				<Menu.Item onClick={() => this.setState({ showTransferToLocation: true })}>
					To Location
				</Menu.Item>
				<Menu.Item onClick={() => this.setState({ showTransferToStockLocation: true })}>
					To Stock Location
				</Menu.Item>
			</Menu>
		);

		const rowSelection = {
			selectedRowKeys,
			onChange: (keys, rows) => this.setState({ selectedRowKeys: keys, selectedRows: rows }),
			getCheckboxProps: (record) => {
				const wouldMix =
					selectedRowKeys.length > 0 &&
					((hasScheduledSelected && !record.nextScheduledTransfer) ||
						(hasUnscheduledSelected && record.nextScheduledTransfer));
				return {
					disabled: wouldMix,
					title: wouldMix
						? "Scheduled and unscheduled assets can't be selected together"
						: undefined,
				};
			},
		};

		return (
			<>
				<ReduxDataTable
					handleQueryParams
					filterConfig={filterConfig}
					entityCollectionName="assets"
					rowSelection={rowSelection}
					rightActions={
						<Col className={'flex items-baseline'} style={{ gap: 8 }}>
							{selectedRowKeys.length > 0 ? (
								<>
									<span className="bodyregular text-grey-8">{selectedRowKeys.length} selected</span>
									<Button
										size="large"
										type="link"
										onClick={() => this.setState({ selectedRowKeys: [], selectedRows: [] })}
									>
										Clear selection
									</Button>
									{hasScheduledSelected ? (
										<Popconfirm
											title={`Cancel scheduled transfer for ${selectedRowKeys.length} asset(s)?`}
											onConfirm={this.cancelTransfer}
											okText="Cancel Transfer"
											cancelText="Keep"
											okButtonProps={{ danger: true }}
										>
											<Button size="large" danger type="primary">
												Cancel Transfer
											</Button>
										</Popconfirm>
									) : (
										<Dropdown overlay={transferMenu}>
											<Button size="large" type="primary">
												Transfer <DownOutlined />
											</Button>
										</Dropdown>
									)}
								</>
							) : (
								<>
									<Dropdown overlay={downloadMenu}>
										<Button key={1} size="large">
											<div className="flex flex-row">
												<DownloadOutlined />
											</div>
										</Button>
									</Dropdown>
									<BulkTransferAssetsButton onSuccess={this.refreshAssets} />
									<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
										<Button
											size="large"
											type="primary"
											onClick={() => this.props.history.push('/supplier/assets/overview/new')}
										>
											Add Asset
										</Button>
									</AccessPermissionChecker>
								</>
							)}
						</Col>
					}
					updateQueryParams={true}
					emptyState={
						<EmptyState
							graphic={
								<img
									style={{ marginBottom: 8 }}
									src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
									alt="Add your first asset"
								/>
							}
							headline={"It's a little lonely in here."}
							body={
								<div style={{ textAlign: 'center' }}>
									<div style={{ maxWidth: 440, marginBottom: 16 }}>
										Looks like your team has not added any assets yet.
									</div>
									<Button
										type="primary"
										onClick={() => this.props.history.push('/supplier/assets/overview/new')}
									>
										Add your first asset
									</Button>
								</div>
							}
						/>
					}
					onTableRow={onRow}
					showHeader={false}
					targetCollectionName="assetsIndex"
					tableColumns={columns}
					keyAccessor={(el) => el.id}
					initialFilters={{ ...this.initialFilters, ...INITIAL_ACTIVE_FILTERS }}
					initialPagination={this.initialPagination}
					fetchData={assetsRestCrudThunksForSupplier}
					stateSlice={assets}
					initialSorting={{ sort_by: 'name', order: 'ascend' }}
				/>
				{showTransferToStockLocation && (
					<BulkTransferToStockLocationModal
						assetIds={selectedRowKeys}
						onCancel={() => this.setState({ showTransferToStockLocation: false })}
						onSuccess={() => {
							this.setState({ selectedRowKeys: [], showTransferToStockLocation: false });
							this.refreshAssets();
						}}
					/>
				)}
				{showTransferToLocation && (
					<BulkTransferToLocationModal
						assetIds={selectedRowKeys}
						onCancel={() => this.setState({ showTransferToLocation: false })}
						onSuccess={() => {
							this.setState({ selectedRowKeys: [], showTransferToLocation: false });
							this.refreshAssets();
						}}
					/>
				)}
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	assets: state.assets,
	assetTypes: state.asset_types,
	areas: state.areas,
	locations: state.locations,
	depreciationClasses: state.depreciation_classes,
	assetTypesAdditionalFields: state.asset_types_additional_fields,
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
	vendors: state.vendors,
});

const mapDispatchToProps = (dispatch) => ({
	updateAssetsFilters: (filters, targetCollection) =>
		dispatch(ASSETS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(ASSETS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)),
	fetchMultipleAssetTypes: (ids, targetCollectionName) =>
		dispatch(assetTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchAssetTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			assetTypesRestCrudThunksForSupplier.readLite(
				{ ...params, no_pagination: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAssetTypesAdditionalFields: (ids, targetCollectionName) =>
		dispatch(
			assetTypesAdditionalFieldsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
		),
	fetchAssetTypesAdditionalFields: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			assetTypesAdditionalFieldsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(locationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForSupplier.readLite(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchAreas: (params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
		dispatch(
			fetchAreasWithHeirarchy(ROLE_TYPES.SUPPLIER)(
				{ ...params, no_pagination: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAreas: (ids, targetCollectionName) =>
		dispatch(areasRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	downloadAssetCSV: (params, filters) => dispatch(downloadAssetCSVForSupplier(params, filters)),
	fetchDepreciationClasses: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			depreciationClassesRestCrudThunksForSupplier.readLite(
				{ ...params, no_pagination: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleDepreciationClasses: (ids, targetCollectionName) =>
		dispatch(depreciationClassesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	downloadAssetNBV: (params, filters) => dispatch(downloadAssetNBVCSVForSupplier(params, filters)),
	fetchVendors: (params, targetCollectionName) =>
		dispatch(
			vendorsRestCrudThunksForSupplier.readLite(
				{ ...params, isActive: true, no_pagination: true },
				targetCollectionName
			)
		),
	fetchMultipleVendors: (ids, targetCollectionName) =>
		dispatch(vendorsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchAssets: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			assetsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	cancelScheduledTransfer: (data) =>
		dispatch(cancelScheduledAssetTransfer(ROLE_TYPES.SUPPLIER)(data)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(SupplierAssetsIndexPage)
);
